import $ from 'jquery';

function onSuccess(location) {
  // console.log(JSON.stringify(location, undefined, 4));
  const isoCode = location.country.iso_code;
  const name = location.country.names.en;

  // console.log(isoCode);
  // console.log(name);

  // const elem = document.querySelector('#geoIP_country');
  // elem.innerHTML = name;

  $('#geoIP_locateHere').on('click', () => {
    showSwitcher();
    // console.log(Cookies.get("currencyLocationConfirmed"));
  });
}

function onError(error) {
  console.log(`Error:\n\n${JSON.stringify(error, undefined, 4)}`);

  $('.currency-switcher').hide();
}

function setCookie() {
  Cookies.set('currencyLocation', true, {expires: 300, path: ''});
}

function showSwitcher() {
  $('.currency-switcher__topBar').show();
}

if (
  document.body.classList.contains('template-cart')
  // || document.body.classList.contains('template-register')
) {
  console.log('⛔️ No currency conversion on this page');
} else {
  // Currency Select Customiser
  $('.currency-switcher select').each(function () {
    const $this = $(this);
    const numberOfOptions = $(this).children('option').length;

    // const codeOnLoad = $this.children('option:selected').val();
    const locOnLoad = $this.children('option:selected').text();
    const flagOnLoad = $this.children('option:selected').data('flag');

    // console.log(`${locOnLoad} - ${ccOnLoad}`);

    $this.addClass('select-hidden');
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    const $styledSelect = $this.next('div.select-styled');
    $styledSelect.html(
      `<span> ${locOnLoad} </span> <img src="${flagOnLoad}" loading="lazy" />`,
    );

    $styledSelect.html(`<span> ${locOnLoad} </span>`);

    const $list = $('<ul />', {
      class: 'select-options',
    }).insertAfter($styledSelect);

    for (let i = 0; i < numberOfOptions; i++) {
      const flag = $this.children('option').eq(i).data('flag');
      $('<li />', {
        html: `${$this
          .children('option')
          .eq(i)
          .text()} <img src="${flag}" loading="lazy" />`,
        // html: `${$this.children('option').eq(i).text()}`,
        rel: $this.children('option').eq(i).val(),
      }).appendTo($list);
    }

    const $listItems = $list.children('li');

    $styledSelect.click(function (e) {
      e.stopPropagation();
      $('div.select-styled.active')
        .not(this)
        .each(function () {
          $(this).removeClass('active').next('ul.select-options').hide();
        });
      $(this).toggleClass('active').next('ul.select-options').toggle();
    });

    $listItems.click(function (e) {
      e.stopPropagation();
      $styledSelect.text($(this).text()).removeClass('active');
      $this.val($(this).attr('rel'));
      $list.hide();
      showSwitcher();
      // Removed modal
      $('form#localization_form').submit();
    });

    $(document).click(() => {
      $styledSelect.removeClass('active');
      $list.hide();
    });
  });

  if (typeof geoip2 === 'undefined') {
    console.log('🌍🚨 GeoIP2 Undefined');
  } else {
    const c = geoip2.city(onSuccess, onError);
    // console.log(c);
  }
}
